<tbody>
<tr>
  <td class="answer">
    <div class="input-group big active">
              <span class="cross-icon" (click)="clearAnswer()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <defs>
                    <style>.task_no_question-close-cls-1,.task_no_question-close-cls-2{fill:none;}.task_no_question-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;} .cross-icon:hover .task_no_question-close-cls-2{stroke:#999999;stroke-miterlimit:10;stroke-width:2px;}</style>
                  </defs>
                  <title></title>
                  <g id="Слой_2" data-name="Слой 2">
                    <g id="Слой_10" data-name="Слой 10">
                      <rect class="task_no_question-close-cls-1" width="24" height="24"/>
                      <line class="task_no_question-close-cls-2" x1="1.5" y1="1.5" x2="22.5" y2="22.5"/>
                      <line class="task_no_question-close-cls-2" x1="1.5" y1="22.5" x2="22.5" y2="1.5"/>
                    </g>
                  </g>
                </svg>
              </span>
      <input type="text" class="text-left" [(ngModel)]="answer" readonly="readonly">
    </div>
  </td>
</tr>
<tr>
  <td class="answer-vars" *ngIf="exercise.words">
    <span *ngFor="let word of exercise.words" (click)="keyboardClicked(word)">
      {{ word }}
    </span>
    <span>
      <a class="enter" style="cursor: pointer;" (click)="checkAnswer()" appDisTouchmove>
        <img src="/assets/images/enter.png" alt="" />
      </a>
    </span>
  </td>
</tr>
</tbody>
